var map = {
	"./conference/best-plays-record.csv": 80150,
	"./conference/defense-record.csv": 76354,
	"./conference/offense-record.csv": 51566,
	"./conference/standings.csv": 66628,
	"./team/3 Least Efficient plays ran.csv": 9302,
	"./team/3 Most Efficient plays.csv": 55673,
	"./team/Coach Analysis South Dakota.csv": 13584,
	"./team/Full Season Stats south dakota.csv": 32279,
	"./team/game-schedule-south-dakota.csv": 23928,
	"./team/player-stats-south-dakota.csv": 62500,
	"./team/south-dakota-all-plays.csv": 11627,
	"./team/south-dakota-least-efficienct-lineup.csv": 14344,
	"./team/south-dakota-most-efficient-lineup.csv": 12135,
	"./teams/Color_Code_for_Teams.csv": 20485,
	"./teams/Team_logo_name_defintions.csv": 88833,
	"./teams/team-stats.csv": 26393,
	"./teams/team_names_and_logos.csv": 86725
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 65156;